import React from "react";

export interface ShimmerTextProps {
  text?: string;
  className?: string;
}

export const ShimmerText: React.FC<ShimmerTextProps> = ({
  text = "Thinking...",
  className = ""
}) => {
  return (
    <div className={`inline-flex items-center ${className}`}>
      <span className="relative inline-block">
        <span className="animate-shimmer bg-[length:200%_100%] bg-gradient-to-r from-neutral-400 via-neutral-600 to-neutral-400 bg-clip-text font-medium text-transparent">
          {text}
        </span>
      </span>
    </div>
  );
};
